/**
 * Class that handles adding a debounce timer for window resize events.
 *
 * Inspiration derived from:  https://medium.com/@TCAS3/debounce-deep-dive-javascript-es6-e6f8d983b7a1
 */
export default class Resize {
  /**
   * Control how often a window resize event handler is fired.
   *
   * @param {function} debouncedFunction - The function to be called when the window is resized.
   * @param {number} delay - How long to wait, in milliseconds, after the resize event ends before executing @param debouncedFunction.
   */
  constructor({ debouncedFunction, delay }) {


    // ---------- VARIABLES ----------


    this.debouncedFunction = debouncedFunction;
    this.delay = delay;


    // ---------- METHODS ----------


    /**
     * Handles setting the timeout, clearing any existing timeout,
     * and then re-setting the new timeout.
     *
     * @return {function} - The function to be called every time @function this.debounce is called.
     */
    this.debounce = () => {
      let timeout;
      return () => {
        const functionCall = () => { debouncedFunction.call(this, this.delay); };
        window.clearTimeout(timeout);
        timeout = window.setTimeout(functionCall, this.delay);
      };
    };
  }
}
